var React = require('react');

function SadPage (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M16 0v16h16v20a3 3 0 01-3 3H3a3 3 0 01-3-3V3a3 3 0 013-3h13zm0 25.5c-3.376 0-6.014 1.331-7.806 3.958a1 1 0 001.652 1.127C11.257 28.517 13.272 27.5 16 27.5c2.73 0 4.752 1.018 6.176 3.088a1 1 0 101.648-1.133C22.019 26.83 19.374 25.5 16 25.5zM9.5 11a2.5 2.5 0 100 5 2.5 2.5 0 000-5zM18 .004L17.856 0a3 3 0 012.13.887L31.13 12.123A3 3 0 0131.99 14H18V.004z","fill":"#DEE6EC","fillRule":"nonzero"}));
}

SadPage.defaultProps = {"width":"32","height":"39"};

module.exports = SadPage;

SadPage.default = SadPage;
